import { useTranslation } from 'react-i18next'
import React from 'react'

import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import IconPicker from '../../../../components/form/IconPicker'

const GeneralSection = () => {
  const { t } = useTranslation('placeTypes')

  return (
    <>
      <FormItem label={`${t('name')}*`} field="name" />
      <Separator weight={2} />

      <FormItem label={`${t('namePlural')}*`} field="namePlural" />
      <Separator weight={2} />
      <FormItem label={`${t('icon')}*`} field="icon" Input={IconPicker} />
      <Separator weight={2} />
    </>
  )
}

export default GeneralSection
